<template>
    <div style="padding:20px">
        <div >
            <div style="float:right;padding-bottom: 20px;">
                <b>已选充值金额 ￥ {{ money.toFixed(2) }}</b>
                <a-button :loading="loading" @click="rechargeAction" style="margin-left:50px;margin-right: 20px;" type="primary">
                <template #icon><pay-circle-outlined /></template>
                充值
            </a-button>
            </div>
        </div>
        <div>
            <a-table :loading="loading"  rowKey="Id" :row-selection="rowSelection"  :scroll="{ y: tableHeight }"  :pagination="false" :dataSource="list" :columns="columns" >
                <template #bodyCell="{ column,text,record }">
                    <template v-if="column.key === 'num'" >
                        <a-tag color="#2db7f5" >{{text}}</a-tag>
                    </template>
                    <template v-else-if="column.key === 'money'" >
                        <b>{{ text }}</b>
                    </template>
                    <template v-else-if="column.key === 'balance'" >
                        <b>{{ text }}</b>
                    </template>
                    <template v-else-if="column.key === 'commission'" >
                        <b>{{ text }}</b>
                    </template>

                    <template v-else-if="column.key === 'rechargeMoney'" >
                        <a-input-number @change="changeMoney" v-model:value="record.RechargeMoney"   addon-after="￥"></a-input-number>
                    </template>
                </template>
                
            </a-table>
        </div>

        <a-modal v-model:visible="visible" title="充值" style="width:700px" :confirmLoading="confirmLoading" @ok="handleOk">
            <div v-if="!isUseBalance">
                <div  style="text-align: center;margin-bottom: 20px;"><b>请往以下任意账户转账 <span style="color:red">{{ money.toFixed(2) }}</span> 元</b></div>
                <a-card v-if="collection.OneAlipayName">
                    <a-row>
                        <a-col :span="4">
                            <alipay-outlined /> 支付宝
                        </a-col>
                        <a-col :span="4">
                            {{collection.OneAlipayName}}
                        </a-col>
                        <a-col :span="6">
                            
                        </a-col>
                        <a-col :span="10">
                            {{collection.OneAlipayAccount}}
                        </a-col>
                    </a-row>
                </a-card>
                <a-card style="margin-top:20px" v-if="collection.OneBank">
                    <a-row>
                        <a-col :span="4">
                            <credit-card-outlined /> 银行卡
                        </a-col>
                        <a-col :span="4">
                            {{collection.OneBankName}}
                        </a-col>
                        <a-col :span="6">
                            {{collection.OneBank}}
                        </a-col>
                        <a-col :span="10">
                            {{collection.OneBankAaccount}}
                        </a-col>
                    </a-row>
                </a-card>
                <div  style="margin-top:20px;text-align: center;">
                <a-upload
                    
                    name="avatar"
                    list-type="picture-card"
                    class="avatar-uploader"
                    :show-upload-list="false"
                    :action="baseUrl+'/member/PushImg'" :custom-request="ossDirectUpload"
                    @change="handleChange"
                    accept="image/jpeg,image/png"
                >
                    <img style="width:100%;height:100%" v-if="img" :src="img" alt="avatar" />
                    <div v-else>
                    <loading-outlined v-if="imgLoading"></loading-outlined>
                    <plus-outlined v-else></plus-outlined>
                    <div class="ant-upload-text">上传截图</div>
                    </div>
                </a-upload>
                </div>
            </div>

            <div v-if="canDeduction.CanDeduction" style="text-align: center;margin-top:20px">
                <a-checkbox v-model:checked="isUseBalance">使用余额（{{canDeduction.Balance.toFixed(2) }}）抵扣 <span style="color:red">{{ money.toFixed(2) }}</span>  元</a-checkbox>
            </div>
        </a-modal>
    </div>
</template>
<script>
import {  ref } from 'vue';
import { memberGetArrearsReq,memberGetCollectionReq,memberRechargeReq,uri,agentCanDeductionReq ,memberRechargeUseBalanceReq} from '@/request.js';

// import { useRouter } from 'vue-router';
// import { message } from 'ant-design-vue';
import { PayCircleOutlined,AlipayOutlined,CreditCardOutlined,LoadingOutlined,PlusOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';

export default {
    components: {
        PayCircleOutlined,AlipayOutlined,CreditCardOutlined,LoadingOutlined,PlusOutlined
    },
    setup(){
        const confirmLoading=ref(false);
        const canDeduction=ref();
        agentCanDeductionReq({},(res)=>{
            canDeduction.value=res.Result;
        })
        const isUseBalance=ref(false);
        const img=ref("");
        const imgLoading=ref(false);
        const baseUrl=ref(uri);
        const collection=ref({});
        const visible=ref(false);
        const money=ref(0);
        let memberIdList=[];
        const operateing=ref(false);
        const tableHeight=ref(0);
        tableHeight.value=document.documentElement.clientHeight-260;
        const loading=ref(false);
        const list=ref([]);
        const query=()=>{
            loading.value=true;
            memberGetArrearsReq({
            },(res)=>{
                list.value=res.Result;
                loading.value=false;
            })
        };
        const handleChange = info => {
            if (info.file.status === 'uploading') {
                imgLoading.value = true;
                return;
            }
            if (info.file.status === 'done') {
                if(info.file.response.IsSuccess){
                    img.value=info.file.response.Message;
                }else{
                    message.error('上传失败');
                }
                imgLoading.value = false;
            }
            if (info.file.status === 'error') {
                imgLoading.value = false;
                message.error('上传失败');
            }
        };
        const changeMoney=()=>{
            money.value=0;
            list.value.forEach(element => {
                if(memberIdList.includes(element.Id)){
                    money.value+=element.RechargeMoney;
                }
            });
        }
        const rechargeAction=()=>{
            memberGetCollectionReq({money:money.value},(res)=>{
                collection.value=res.Result;
            })
            img.value="";
            visible.value=true;
        }
        const handleOk=()=>{
            
            if(isUseBalance.value){
                let array=new Array();
                list.value.forEach(element => {
                    if(memberIdList.includes(element.Id)){
                        array.push(element);
                    }
                });
                confirmLoading.value=true;
                memberRechargeUseBalanceReq({json:JSON.stringify(array)},(res)=>{
                    if(res.IsSuccess){
                        message.success('提交成功');
                    }else{
                        message.error(res.Message);
                    }
                    confirmLoading.value=false;
                })
            }else{
                if(img.value){
                    let array=new Array();
                    list.value.forEach(element => {
                        if(memberIdList.includes(element.Id)){
                            array.push(element);
                        }
                    });
                    confirmLoading.value=true;
                    memberRechargeReq({json:JSON.stringify(array),imgSrc:img.value,outsiderId:collection.value.OutsiderId,leaderId:collection.value.leaderId},(res)=>{
                        if(res.IsSuccess){
                            message.success('提交成功');
                        }else{
                            message.error(res.Message);
                        }
                        confirmLoading.value=false;
                    })
                }else{
                    message.error('请上传转账截图');
                }
            }
        }
        const rowSelection = {
            onChange: (selectedRowKeys) => {
                memberIdList=selectedRowKeys;
                money.value=0;
                list.value.forEach(element => {
                    if(memberIdList.includes(element.Id)){
                        money.value+=element.RechargeMoney;
                    }
                });
            },
        };
        query();
        return{
            confirmLoading,
            isUseBalance,
            canDeduction,
            handleChange,
            img,
            imgLoading,
            baseUrl,
            handleOk,
            visible,
            collection,
            rechargeAction,
            rowSelection,
            money,
            operateing,
            tableHeight,
            loading,
            list,
            changeMoney,
            query,
            columns: [
                {
                    title: '商家名称',
                    dataIndex: 'Name',
                    key: 'name',
                },
                {
                    title: '商家账号',
                    dataIndex: 'Phone',
                    key: 'phone',
                },
                {
                    title: '当前欠款',
                    dataIndex: 'BalanceText',
                    key: 'balance',
                },
                {
                    title: '昨日货佣',
                    dataIndex: 'MoneyText',
                    key: 'money',
                },
                {
                    title: '昨日佣金',
                    dataIndex: 'CommissionText',
                    key: 'commission',
                },
                {
                    title: '充值金额',
                    dataIndex: 'RechargeMoney',
                    key: 'rechargeMoney',
                },
            ],
        }
    }
}
</script>
